<template>
  <div class="flex flex-col gap-1.5">
    <label
      v-if="label"
      :for="inputId"
      class="block text-sm font-medium text-gray-900"
    >
      {{ label }}
    </label>
    <input
      :id="inputId"
      :value="modelValue"
      :type="type"
      :inputmode="inputmode"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :data-cy="dataCy"
      :class="[
        'w-full border rounded-md px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400',
        'focus:outline-none focus:ring-1 focus:border-blue-500 focus:ring-blue-500',
        'disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed',
        errorMessage ? 'border-red-400' : 'border-gray-300'
      ]"
      @input="
        emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
      @keypress="emit('keypress', $event)"
    />
    <span v-if="errorMessage" class="text-xs text-red-600">{{
      errorMessage
    }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed, useId } from "vue";

withDefaults(
  defineProps<{
    modelValue: string | number | null;
    label?: string;
    type?: string;
    inputmode?:
      | "none"
      | "text"
      | "tel"
      | "url"
      | "email"
      | "numeric"
      | "decimal"
      | "search";
    placeholder?: string;
    autocomplete?: string;
    errorMessage?: string;
    disabled?: boolean;
    dataCy?: string;
  }>(),
  {
    label: "",
    type: "text",
    inputmode: undefined,
    placeholder: "",
    autocomplete: "off",
    errorMessage: "",
    disabled: false,
    dataCy: undefined
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "keypress", event: KeyboardEvent): void;
}>();

const autoId = useId();
const inputId = computed(() => `pf-input-${autoId}`);
</script>
